import { Pipe, PipeTransform } from '@angular/core';
import { TMarkedDefect } from '@monorepo/types';
import * as _ from 'lodash';
import { TSilhouetteMarkers } from './FrontSilhouetteDefectMarker.pipe';

@Pipe({
  name: 'backMarkers',
})
export class BackSilhouetteDefectMarkerPipe implements PipeTransform {
  transform(markedDefects: TMarkedDefect[]): TSilhouetteMarkers {
    const filterMarkedDefects = markedDefects.filter((v) => v.silhuetteType === 'BACK');
    return _.flatten(
      filterMarkedDefects.map((v) =>
        v.coordinate.map((c) => ({
          color: v.color,
          coordinates: c,
        })),
      ),
    );
  }
}
